import { __awaiter, __generator } from "tslib";
import { initialize, LogKind, log } from '@ms/centro-hvc-loader';
import { CentroUrlProd, DefaultMajorVersion, PerfPrefix, TelemetryIdError, TelemetryIdInfo, TelemetryPrefix, guidRegexPattern, } from './Constants';
export var getCentroParams = function (initializationInfo) {
    var hostName = initializationInfo.hostName, locale = initializationInfo.locale, centroUrl = initializationInfo.centroUrl, specificHvcVersion = initializationInfo.specificHvcVersion, majorVersion = initializationInfo.majorVersion, centroHvcData = initializationInfo.centroHvcData, enableUxVersionQueryParam = initializationInfo.enableUxVersionQueryParam, telemetryAppId = initializationInfo.telemetryAppId;
    var initializationConfig = {
        hostName: hostName,
        locale: locale,
        appId: telemetryAppId,
        // All perf log will be prefixed with this string.
        // So that when we analyze perf logs, we know that those logs are coming from HVC running in your environment.
        perfPrefix: PerfPrefix + "_" + hostName,
    };
    var centroParams = {
        centroEnvironmentBaseUrl: centroUrl !== null && centroUrl !== void 0 ? centroUrl : CentroUrlProd,
        preConfig: initializationConfig,
        // Note: do not specify both forHostVersion and hvcVersion
        forHostVersion: majorVersion !== null && majorVersion !== void 0 ? majorVersion : DefaultMajorVersion,
        hvcVersion: '',
        centroHvcData: centroHvcData !== null && centroHvcData !== void 0 ? centroHvcData : '',
        enableUxVersionQueryParam: enableUxVersionQueryParam, // get uxversion information with query params instead of request headers (recommended)
    };
    if (specificHvcVersion) {
        centroParams.hvcVersion = specificHvcVersion;
        centroParams.forHostVersion = '';
        return centroParams;
    }
    return centroParams;
};
/**
 * Logs info into the centro telemetry
 */
export function logInAppFeedbackInfo(text) {
    log({ type: LogKind.Info, message: TelemetryPrefix + ": " + text, id: TelemetryIdInfo });
}
/**
 * Logs errors into the centro telemetry
 */
export function logInAppFeedbackError(text, error) {
    log({ type: LogKind.Error, message: TelemetryPrefix + ": " + text, id: TelemetryIdError, error: error });
    throw error;
}
export function validateInitializationParameters(initializationInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var inAppFeedbackRef, hostName, locale, telemetryAppId, missingParameterError, errorMessageList, parameterError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inAppFeedbackRef = initializationInfo.inAppFeedbackRef, hostName = initializationInfo.hostName, locale = initializationInfo.locale, telemetryAppId = initializationInfo.telemetryAppId;
                    missingParameterError = 'is a mandatory parameter';
                    errorMessageList = [];
                    if (!inAppFeedbackRef) {
                        errorMessageList.push("inAppFeedbackRef " + missingParameterError);
                    }
                    if (!hostName) {
                        errorMessageList.push("hostName " + missingParameterError);
                        initializationInfo.hostName = 'OcvFeedbackDemoHostingApp'; // setting a default value to make sure initialize is not failing
                    }
                    if (!locale) {
                        errorMessageList.push("locale " + missingParameterError);
                        initializationInfo.locale = 'en'; // setting a default value to make sure initialize is not failing
                    }
                    if (telemetryAppId && !guidRegexPattern.test(telemetryAppId)) {
                        errorMessageList.push('telemetryAppId needs to be GUID');
                    }
                    if (!(errorMessageList.length > 0)) return [3 /*break*/, 2];
                    // This is to enable dynamic logging endpoint to be GDPR and EUDB compliant
                    return [4 /*yield*/, initialize(getCentroParams(initializationInfo))];
                case 1:
                    // This is to enable dynamic logging endpoint to be GDPR and EUDB compliant
                    _a.sent();
                    parameterError = new Error(JSON.stringify(errorMessageList));
                    logInAppFeedbackError('Initialization parameter Error: ', parameterError);
                    if (initializationInfo.onInitializationError) {
                        initializationInfo.onInitializationError(parameterError);
                    }
                    throw parameterError;
                case 2: return [2 /*return*/];
            }
        });
    });
}
